import TaxiCorporationPlanEntryBillingsRequest, {
  TaxiCorporationPlanEntryBillingsRequestBillingModel,
  TaxiCorporationPlanEntryBillingsRequestOrder,
} from "../../../../api/raily/taxi-corporation/plan-entry-billings/list/taxi-corporation-plan-entry-billings.request";
import BillingModel from "../../../../types/billing-model";
import TaxiCorporationSortKey from "../../../../types/taxi-corporation-sort-key";
import paginationService from "../../../../utils/pagination/pagination.service";
import TaxiCorporationPlanEntryBillingsParams from "./taxi-corporation-plan-entry-billings-params";

const createModel = (
  model: BillingModel | undefined,
): TaxiCorporationPlanEntryBillingsRequestBillingModel | undefined => {
  switch (model) {
    case BillingModel.AB:
      return TaxiCorporationPlanEntryBillingsRequestBillingModel.AB;
    case BillingModel.ABA:
      return TaxiCorporationPlanEntryBillingsRequestBillingModel.ABA;
    case BillingModel.OTHER:
      return TaxiCorporationPlanEntryBillingsRequestBillingModel.OTHER;
    case BillingModel.SABS:
      return TaxiCorporationPlanEntryBillingsRequestBillingModel.SABS;
    default:
      return undefined;
  }
};

const createOrder = (
  sortKey: TaxiCorporationSortKey | undefined,
): TaxiCorporationPlanEntryBillingsRequestOrder | undefined => {
  switch (sortKey) {
    case TaxiCorporationSortKey.BILLING_MODEL_ASC:
      return TaxiCorporationPlanEntryBillingsRequestOrder.BILLING_MODEL_ASC;
    case TaxiCorporationSortKey.BILLING_MODEL_DESC:
      return TaxiCorporationPlanEntryBillingsRequestOrder.BILLING_MODEL_DESC;
    case TaxiCorporationSortKey.DISTANCE_AMOUNT_ASC:
      return TaxiCorporationPlanEntryBillingsRequestOrder.DISTANCE_AMOUNT_ASC;
    case TaxiCorporationSortKey.DISTANCE_AMOUNT_DESC:
      return TaxiCorporationPlanEntryBillingsRequestOrder.DISTANCE_AMOUNT_DESC;
    case TaxiCorporationSortKey.DISTANCE_ASC:
      return TaxiCorporationPlanEntryBillingsRequestOrder.DISTANCE_ASC;
    case TaxiCorporationSortKey.DISTANCE_DESC:
      return TaxiCorporationPlanEntryBillingsRequestOrder.DISTANCE_DESC;
    case TaxiCorporationSortKey.DISTANCE_RATE_ASC:
      return TaxiCorporationPlanEntryBillingsRequestOrder.DISTANCE_RATE_ASC;
    case TaxiCorporationSortKey.DISTANCE_RATE_DESC:
      return TaxiCorporationPlanEntryBillingsRequestOrder.DISTANCE_RATE_DESC;
    case TaxiCorporationSortKey.DRIVER_ASC:
      return TaxiCorporationPlanEntryBillingsRequestOrder.DRIVER_ASC;
    case TaxiCorporationSortKey.DRIVER_DESC:
      return TaxiCorporationPlanEntryBillingsRequestOrder.DRIVER_DESC;
    case TaxiCorporationSortKey.HIGHWAY_CHARGE_ASC:
      return TaxiCorporationPlanEntryBillingsRequestOrder.HIGHWAY_CHARGE_ASC;
    case TaxiCorporationSortKey.HIGHWAY_CHARGE_DESC:
      return TaxiCorporationPlanEntryBillingsRequestOrder.HIGHWAY_CHARGE_DESC;
    case TaxiCorporationSortKey.HUMAN_ID_ASC:
      return TaxiCorporationPlanEntryBillingsRequestOrder.HUMAN_ID_ASC;
    case TaxiCorporationSortKey.HUMAN_ID_DESC:
      return TaxiCorporationPlanEntryBillingsRequestOrder.HUMAN_ID_DESC;
    case TaxiCorporationSortKey.TOTAL_AMOUNT_ASC:
      return TaxiCorporationPlanEntryBillingsRequestOrder.TOTAL_AMOUNT_ASC;
    case TaxiCorporationSortKey.TOTAL_AMOUNT_DESC:
      return TaxiCorporationPlanEntryBillingsRequestOrder.TOTAL_AMOUNT_DESC;
    default:
      return undefined;
  }
};

const create = (
  params: TaxiCorporationPlanEntryBillingsParams,
): TaxiCorporationPlanEntryBillingsRequest => {
  return {
    limit: params.pageSize,
    offset: paginationService.calculateOffset(params.page, params.pageSize),
    taxiCorporationUuid: params.taxiCorporationUuid,
    billingModel: createModel(params.billingModel),
    cargoOrderHumanId: params.cargoOrderHumanId,
    dateSince: params.dateSince,
    dateTo: params.dateTo,
    driver: params.driver,
    fleetPartner: params.fleetPartner,
    humanId: params.humanId,
    order: createOrder(params.sortKey),
  };
};

const taxiCorporationPlanEntryBillingsParamsFactory = {
  create,
};

export default taxiCorporationPlanEntryBillingsParamsFactory;
